<template>
  <div class="main-content">
    <div class="sale-page">
      <div class="container">
        <h2 class="sale-page__login-title">選擇會員</h2>

        <b-tabs
          v-model="tabIndex"
          content-class="mt-3"
          justified
          class="choose-member-tab"
        >
          <b-tab title="一般會員" active>
            <ValidationObserver ref="form" class="validate-area">
              <div class="location-choose-area">
                <div class="location-choose-area__title">
                  銷售分店
                </div>
                <ValidationProvider
                  :rules="{
                    required: true
                  }"
                  v-slot="{ errors, failed }"
                  name="location"
                >
                  <ul class="location-menu row" :class="{ failedin: failed }">
                    <Location
                      v-for="(oneLocation, index) in locationOptions"
                      :key="index"
                      :oneLocation="oneLocation"
                      v-model="location"
                    />
                  </ul>
                  <span class="warn">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </ValidationObserver>
            <div class="single-input-field">
              <p class="input-title">手機號碼</p>
              <div class="custom-input">
                <input
                  type="text"
                  class="custom-text mobile"
                  :placeholder="'請輸入手機號碼'"
                  name="mobile"
                  v-model="mobile"
                  autocomplete="off"
                />
              </div>
            </div>
          </b-tab>
          <b-tab title="企業會員">
            <ValidationObserver ref="form" class="validate-area">
              <div class="location-choose-area">
                <div class="location-choose-area__title">
                  銷售分店
                </div>
                <ValidationProvider
                  :rules="{
                    required: true
                  }"
                  v-slot="{ errors, failed }"
                  name="location"
                >
                  <ul class="location-menu row" :class="{ failedin: failed }">
                    <Location
                      v-for="(oneLocation, index) in locationOptions"
                      :key="index"
                      :oneLocation="oneLocation"
                      v-model="location"
                    />
                  </ul>
                  <span class="warn">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </ValidationObserver>
            <div class="the-line">
              <div class="text-inline">or</div>
            </div>
            <div class="single-input-field">
              <p class="input-title">統一編號</p>
              <div class="custom-input">
                <input
                  type="text"
                  class="custom-text uniformNum"
                  :placeholder="'請輸入統一編號'"
                  name="uniformNum"
                  v-model="uniformNum"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="the-line">
              <div class="text-inline">or</div>
            </div>
            <div class="single-input-field">
              <p class="input-title">電話號碼</p>
              <div class="custom-input">
                <input
                  type="text"
                  class="custom-text phone"
                  :placeholder="'請輸入電話號碼'"
                  name="phone"
                  v-model="phone"
                  autocomplete="off"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>

        <button class="confirm-btn custom-btn" @click="attemptFetchMember">
          確認
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { localize } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW.json';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { fetchBranches } from '@/api/branch';
import Location from '@/components/Register/Location';
// import { registerMember } from '@/api/register';

export default {
  components: {
    Location
  },
  data() {
    return {
      mobile: '',
      uniformNum: '',
      phone: '',
      tabIndex: 0,
      object: [],

      location: '',
      locationOptions: []
    };
  },
  computed: {
    ...mapGetters('user', ['branchId']),
    fetchMemberParams() {
      if (this.tabIndex == 0) {
        this.$set(this.object, 'phone', this.mobile);
      } else if (this.tabIndex == 1) {
        if (this.phone != '') {
          this.$set(this.object, 'phone', this.phone);
        }
        if (this.uniformNum != '') {
          this.$set(this.object, 'tax_id', this.uniformNum);
        }
      }
      this.$set(this.object, 'type', this.tabIndex == 0 ? 1 : 2);

      this.$set(this.object, 'cb', () => {
        this.$router.push({ name: '歷史購買紀錄' }).catch(() => {});
      });

      this.$set(this.object, 'branch_id', this.location);

      return this.object;
    },
    switchIdToName() {
      if (this.location) {
        return this.locationOptions.find(
          location => location.branch_id === this.location
        ).name;
      } else {
        return null;
      }
    }
  },
  watch: {
    branchId() {
      this.setDefaultBranch();
    }
  },
  created() {
    localize({
      zh_TW: {
        messages: zh_TW.messages,
        names: {
          location: '分店'
        },
        fields: {
          location: {
            required: '請選擇分店'
          }
        }
      }
    });

    this.fetchBranches();

    this.clearBranch();

    this.setDefaultBranch();
  },
  methods: {
    ...mapMutations('user', ['setUserClickBranch']),
    ...mapActions('user', ['clearBranch']),
    ...mapActions('member', ['chooseMember']),
    attemptFetchMember() {
      // this.submit();
      this.setUserClickBranch(this.switchIdToName);
      this.chooseMember(this.fetchMemberParams);
    },
    // submit() {
    //   this.$refs.form.validate().then(success => {
    //     if (success) {
    //       registerMember({
    //         branch_id: this.location
    //       });
    //     } else {
    //       alert('欄位填寫錯誤');
    //     }
    //   });
    // },
    fetchBranches() {
      fetchBranches(branches => {
        this.locationOptions = branches;
      });
    },
    setDefaultBranch() {
      if (this.branchId != undefined) {
        this.location = this.branchId;
      }
    }
  }
};
</script>
